import React, { useMemo, useCallback } from 'react';
import './title.sass';

// Constantes
const TOGGLE_KEYS = ['Enter', ' '];
const ACTIONS = { show: 'Mostrar', hide: 'Ocultar' };
const CSS_CLASSES = {
  base: 'container-home-event-title',
  hidden: 'hide-list-cards'
};

// Helper functions
const getDisplayName = (sport) => {
  const name = sport?.name || sport?.sport_code || 'Deporte';
  return String(name).toUpperCase();
};

const createToggleText = (isVisible, displayName) => 
  `${isVisible ? ACTIONS.hide : ACTIONS.show} eventos de ${displayName}`;

/**
 * Componente de título para secciones de deportes con funcionalidad de toggle
 */
const Title = React.memo(({ sport, isVisible = true, onToggle }) => {
  
  const displayName = useMemo(() => getDisplayName(sport), [sport]);
  const toggleText = useMemo(() => createToggleText(isVisible, displayName), [isVisible, displayName]);
  
  // Memoizar className para evitar recálculos
  const className = useMemo(() => 
    `${CSS_CLASSES.base}${!isVisible ? ` ${CSS_CLASSES.hidden}` : ''}`,
    [isVisible]
  );
  
  const handleClick = useCallback((e) => {
    e.preventDefault();
    if (typeof onToggle === 'function') {
      onToggle();
    } else {
      console.warn('Title: onToggle prop should be a function');
    }
  }, [onToggle]);
  
  const handleKeyDown = useCallback((e) => {
    if (TOGGLE_KEYS.includes(e.key)) {
      e.preventDefault();
      handleClick(e);
    }
  }, [handleClick]);
  
  if (!sport) {
    console.warn('Title: sport prop is required');
    return null;
  }

  return (
    <div 
      className={className}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      title={toggleText}
      aria-expanded={isVisible}
      aria-label={`${displayName} - ${toggleText}`}
    > 
      <span className="title-major" title={`Eventos de ${displayName}`}>
        {displayName}
      </span>
      
    </div>
  );
});

Title.displayName = 'Title';
export default Title;